import { useAppSelector } from '@/Application/Hooks/Redux';
import type { IBasketSummary } from '@/modules/perseo-billing/interfaces';
import type { IOrderConfirmation } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

type DeliveryHeaderProps = {
  delivery: IBasketSummary;
  index: number;
};

export const DeliveryHeader = ({ delivery, index }: DeliveryHeaderProps) => {
  const paymentSuccess = useAppSelector(
    (state) => state.billing.paymentSuccess as IOrderConfirmation
  );

  const isNovios = paymentSuccess?.basketSummary?.find(
    (basket) => basket?.deliveryDetails?.shippingMethodType === 'novios'
  );
  return (
    <div className="co-flex co-flex-col lg:co-flex-row lg:co-justify-between co-gap-8px">
      <div tabIndex={0} className="co-flex co-gap-8px co-items-center">
        <Icon
          icon="ShoppingBagIcon"
          width={24}
          height={24}
          color="#0B0B0B"
          className="co-fill-current co-text-pds-neutral-900"
        />
        <Typography weight="semibold">
          {'Entrega'} {index}
        </Typography>
      </div>
      <div tabIndex={0} className="co-flex co-py-4px co-gap-10px">
        {delivery?.soldBy && (
          <Typography color="neutral-grey-500" noWrap>
            {'Vendido por '}
            <span className="co-font-medium co-text-pds-neutral-800">
              {delivery?.soldBy}
            </span>
          </Typography>
        )}
        {isNovios
          ? null
          : delivery?.sendBy && (
              <>
                <Typography color="neutral-grey-500">|</Typography>
                <Typography color="neutral-grey-500" noWrap>
                  {'Enviado por '}
                  <span className="co-font-medium co-text-pds-neutral-800">
                    {delivery?.sendBy}
                  </span>
                </Typography>
              </>
            )}
      </div>
    </div>
  );
};

DeliveryHeader.displayName = 'DeliveryHeader';

export default DeliveryHeader;
